import { createContext } from 'react';
import { DealRoom } from 'models/DealRoom';
import utils from 'utils';

export type SearchContextProps = {
  isLoading: boolean;
  isSearching: boolean;
  isSearchOpen: boolean;
  isSearchPage: boolean;
  recentSearches: string[];
  recentlyViewedDeals: DealRoom[];
  addRecentSearch: (term: string) => void;
  removeRecentSearch: (term: string) => void;
  clearRecentSearches: () => void;
  setIsSearching: (value: boolean) => void;
  openSearch: () => void;
  toggleSearch: () => void;
};

export default createContext<Partial<SearchContextProps>>({
  isLoading: false,
  isSearching: false,
  isSearchOpen: false,
  isSearchPage: false,
  recentSearches: [],
  recentlyViewedDeals: [],
  addRecentSearch: utils.noop,
  removeRecentSearch: utils.noop,
  clearRecentSearches: utils.noop,
  setIsSearching: utils.noop,
  openSearch: utils.noop,
  toggleSearch: utils.noop,
});
